module.exports = __webpack_public_path__ + "img/food.b3dff263.jpeg";